import { ChangeDetectionStrategy, Component, input, Input, OnChanges, signal } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { ScreenSizes } from '../../../classes/screen-sizes.class';
import { GalleryStatusColorPipe } from '../../../pipes/gallery-status-color.pipe';
import { GalleryStatusIconPipe } from '../../../pipes/gallery-status-icon.pipe';
import { GalleryStatusNamePipe } from '../../../pipes/gallery-status-name.pipe';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { InferredHoverDirective } from '../../../shared/directives/inferred-hover.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { GalleryTeaserUrlPipe } from '../../../shared/pipes/gallery-teaser-url.pipe';
import { RelativeTimePipe } from '../../pipes/relative-time.pipe';

@Component({
  selector: 'app-gallery-item',
  templateUrl: './gallery-item.component.html',
  styleUrls: ['./gallery-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InferredHoverDirective,
    SvgComponent,
    RelativeTimePipe,
    GalleryTeaserUrlPipe,
    GalleryStatusIconPipe,
    GalleryStatusColorPipe,
    TooltipDirective,
    GalleryStatusNamePipe,
  ],
})
export class GalleryItemComponent implements OnChanges {
  @Input() gallery: GalleryDto;
  @Input() galleryPermissions: GalleryDto['permissions'];
  @Input() compact: boolean;
  @Input() publicMode: boolean;
  @Input() darkBackground: boolean;
  @Input() showPasswordProtected: 'meta' | 'full';
  @Input() hoverDisabled: boolean;
  dateMode = input<'created_at' | 'last_changed_at'>(undefined);
  inferredHover = signal(false);
  hover = signal(false);

  ngOnChanges() {
    if (this.hoverDisabled) {
      this.inferredHover.set(false);
      this.hover.set(false);
    }
  }

  startHover() {
    if (this.hoverDisabled) return;
    if (ScreenSizes.screenSize() !== 'desktop') return;
    this.hover.set(true);
  }

  endHover() {
    this.hover.set(false);
  }
}
